import React from 'react';
import { Text, View } from '@react-pdf/renderer';

export const SignArea = () => {
  return (
    <View
      style={{
        height: '128px',
        borderRadius: '10px',
        backgroundColor: '#FCFCFD',
        border: '1px dotted #E4E7EC',
      }}
    >
      <Text
        style={{
          color: '#667085',
          fontSize: '9px',
          textAlign: 'center',
          paddingTop: '104px',
        }}
      >
        Espacio reservado para la firma de los representantes legales
      </Text>
    </View>
  );
};

export default SignArea;
